








import { Component, Vue, Prop } from "vue-property-decorator";
import { BookingBaseImageGen } from "@/services/booking/v1/data-contracts";
import ImageDialog from "@/components/utility/ImageDialog.vue";
@Component({
  components: {
    ImageDialog
  }
})
export default class BookingAttachmentList extends Vue {
  @Prop()
  attachments!: BookingBaseImageGen[];
}
